import { Controller, Scene } from 'scrollmagic';

const controller = new Controller();

export default function (element, options = {}) {
  const { length = 1, onUpdate = () => {}, headerOffset = 0 } = options;
  let index = 0;
  const trigger = document.createElement('div');
  const header = document.querySelector('.header');
  const offset = header ? -(header.clientHeight + headerOffset) : 0;
  let ignoreUpdates = false;
  element.parentElement.insertBefore(trigger, element);
  const scene = new Scene({
    duration: `${length * 120}%`,
    triggerElement: trigger,
    triggerHook: 'onLeave',
    offset,
  }).setPin(element);
  const onProgress = (e) => {
    const newIndex = Math.ceil(length * e.progress) - 1;
    if (newIndex !== index) {
      ignoreUpdates = true;
      onUpdate(newIndex);
      index = newIndex;
      setTimeout(() => {
        ignoreUpdates = false;
      }, 0);
    }
  };
  scene.on('progress', onProgress);
  scene.addTo(controller);
  return (i) => {
    const p = (i + 1) / length;
    if (ignoreUpdates) return;
    scene.off('progress', onProgress);
    controller.scrollTo(scene.triggerPosition() + p * scene.duration());
    setTimeout(() => {
      scene.on('progress', onProgress);
    }, 0);
  };
}
